import { createSlice } from "@reduxjs/toolkit";
import { addNotificationsAPI } from "../../services/addNotifications";
import { isSuccessMessage, isSuccessfulApiResponse } from "../../common/apiResponse";

const data = {
    isLoading: false,
    error: "",
    message: "",
    data: null,
    statusCode: undefined,
};

const notificationsDetailsSlice = createSlice({
    name: "notificationSliceDetails",
    initialState: data,
    reducers: {
        notificationsDetailsSliceInfo(state) {
            state.isLoading = true;
        },
        notificationsDetailsSliceSuccess(state, action) {
            state.isLoading = false;
            state.data = action.payload;
            state.message = "";
        },
        notificationsDetailsSliceFailure(state, action) {
            const payload =
                action.payload && typeof action.payload === "object"
                    ? action.payload
                    : { message: action.payload };
            state.isLoading = false;
            state.message = payload.message ?? "";
            state.statusCode = payload.statusCode;
            state.data = null;
        },
        notificationsDetailsSliceReset(state) {
            state.isLoading = false;
            state.message = "";
            state.data = null;
            state.error = "";
            state.statusCode = undefined;
        },
    },
});

export const notificationHandler =
  (data, options = {}) =>
  async (dispatch) => {
    try {
        dispatch(notificationsSliceAction.notificationsDetailsSliceInfo());
        const response = await addNotificationsAPI(data, options);
        dispatch(notificationsSliceAction.notificationsDetailsSliceSuccess(response));
    } catch (e) {
        const failurePayload =
            e && typeof e === "object" && "message" in e
                ? e
                : { message: e || "Something went wrong." };
        const message = failurePayload?.message ?? "";

        if (
            (failurePayload?.statusCode != null &&
                isSuccessfulApiResponse(failurePayload)) ||
            isSuccessMessage(message)
        ) {
            dispatch(
                notificationsSliceAction.notificationsDetailsSliceSuccess({
                    statusCode: failurePayload?.statusCode ?? 200,
                    message,
                })
            );
            return;
        }

        dispatch(notificationsSliceAction.notificationsDetailsSliceFailure(failurePayload));
    }
};
export default notificationsDetailsSlice.reducer;
export const notificationsSliceAction = notificationsDetailsSlice.actions;
